import { jsx as m } from "react/jsx-runtime";
import { forwardRef as r } from "react";
import o from "styled-components";
import x from "../../TextField/TextField.js";
const f = o(x).withConfig({
  displayName: "StyledTextField"
})([
  "&& .inputAdornmentRoot button{margin:0px;}&& button.clearTextButtonIcon ~ .inputAdornmentRoot{margin-left:-6px;}"
]), c = /* @__PURE__ */ r(({ onChange: n, helperText: i, inputProps: e, size: a = "small", slotProps: t, ...d }, l) => /* @__PURE__ */ m(f, {
  disableClear: !0,
  helperText: i === "" ? void 0 : i,
  size: a,
  ...d,
  variant: "outlined",
  ref: l,
  onChange: n ?? (e == null ? void 0 : e.onChange),
  slotProps: {
    ...t,
    htmlInput: {
      ...e,
      ...t == null ? void 0 : t.htmlInput
    }
  }
}));
c.displayName = "SpecificTextField";
export {
  c as default
};
